var e="getMessages",s="sendMessage";export{e as GET_MESSAGES,s as SEND_MESSAGE};
